import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export default function MOurService({
	title,
	description,
	type,
	className,
}) {
	const classType = `m-our-service--${type}`;

	return (
		<div className={`m-our-service ${className} ${classType}`}>
			<h3 className="title">
				<FormattedMessage id={title} defaultMessage="" />
			</h3>
			<p className="description">
				<FormattedMessage id={description} defaultMessage="" />
			</p>
		</div>
	);
}

MOurService.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.any.isRequired,
	type: PropTypes.string,
	className: PropTypes.string,
};

MOurService.defaultProps = {
	className: '',
	type: 'left',
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.our-service.js